import React, { useContext, useEffect } from "react";
import { LoadingContainer } from "go-core/components/Loading";
import { PurchaseContext } from "../../pages/Preview";
import PurchaseCorrectionsCard from "../PurchaseCorrections/components/PurchaseCorrectionsCard";
import OrganizationOrderPurchaseCorrectionPage from "../PurchaseCorrections/pages";

const PurchaseCorrectionsTab = () => {
	const { fetchPurchaseCorrections, purchaseCorrections } = useContext(PurchaseContext);

	useEffect(() => {
		fetchPurchaseCorrections();
	}, []);

	if (!purchaseCorrections) return <LoadingContainer />;

	return (
		<div className="col px-0">
			<PurchaseCorrectionsCard />
			<OrganizationOrderPurchaseCorrectionPage />
		</div>
	);
};

export default PurchaseCorrectionsTab;
